<template>
  <div class="alta-proveedor--container">
    <div class="proveedor--container__wrapper">
      <div class="row">
        <h2>Alta de proveedor</h2>
      </div>
      <div class="alta--container">

        <div>
          <div class="row--input">
            <label for="nombre">Nombre</label>
            <input type="text" id="nombre" name="nombre" placeholder="Nombre" v-model="nombre">
          </div>
          <div class="row--input">
            <label for="">Número telefónico</label>
            <input type="phone" id="telefono" name="telefono" placeholder="Número telefónico" v-model="telefono">
          </div>
          <div class="row--input">
            <label for="calle">calle</label>
            <input type="text" id="calle" name="calle" placeholder="Calle" v-model="calle">
          </div>
          <div class="row--input">
            <label for="barrio">Barrio</label>
            <input type="text" id="barrio" name="barrio" placeholder="Barrio" v-model="barrio">
          </div>
          <div class="row--input">
            <label for="barrio">Municipio</label>
            <input type="text" id="municipio" name="municipio" placeholder="Municipio" v-model="municipio">
          </div>

          <div class="row--input">
            <label for="porcentaje">Porcentaje de comisión</label>
            <input type="number" id="porcentaje" name="porcentaje" placeholder="Porcentaje de comisión" v-model="comision">
          </div>
          <div class="row--input">
            <label for="latitud">Latitud</label>
            <input type="number" id="latitud" name="latitud" placeholder="Latitud de la ubicación" v-model="ubicacion.latitud">
          </div>
          <div class="row--input">
            <label for="longitud">Longitud</label>
            <input type="number" id="longitud" name="longitud" placeholder="longitud de la ubicación" v-model="ubicacion.longitud">
          </div>

          <button @click="altaEmpleado">Agregar proveedor</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProveedorAlta',
  data() {
    return{
      nombre: '',
      telefono: '',
      calle: '',
      barrio: '',
      municipio: '',
      comision: '',
      ubicacion: {
        latitud: 0,
        longitud: 0
      }
    }
  },
  methods: {
    altaEmpleado(){
      const self = this;
      const db = this.$firebase.firestore();
      const id = 'tux-' + this.nombre.replace(/\s/g,'-');
      db.collection("proveedores")
        .doc(id)
        .set({
          id: id,
          nombre: this.nombre,
          telefono: this.telefono,
          calle: this.calle,
          barrio: this.barrio,
          municipio: this.municipio,
          comision: this.comision,
          ubicacion: this.ubicacion,
          fecha: new Date()
        })
        .then( function() {

        })
        .catch( function () {

        });
    }
  }
}
</script>

<style lang="sass">
.alta-empleados--container
  height: calc( 100% - 20px )
  padding-top: 10px
  width: 100%
  .empleados--container__wrapper
    display: grid
    grid-template-rows: 50px 1fr
    padding: 20px
    .alta--container
      height: 500px
      width: 800px

.row
  display: inline-block
  width: 100%
.row--input
  width: 100%
  height: 40px
  display: flex
  text-align: left
  padding-bottom: 12px
  align-items: center
  label
    width: 180px
    justify-content: left
  input
    font-size: 18px
    height: 40px

button
  height: 40px
  padding: 0 20px
  background: #02e079
  font-size: 18px
  color: white
  border: none
</style>
